import { useMoveToWebview } from './moveToWebview';
import { moveToToday } from './moveToToday';
import { useMoveToScreens } from './moveToScreens';
import { useMoveToHome } from './moveToHome';
import { useMoveToLikeFolders } from './moveToLikeFolders';
import { useMoveToLikeMarketList } from './moveToLikeMarketList';
import { useMoveToEditGoodsLike } from './moveToEditGoodsLike';
import { moveToRoot } from './moveToRoot';
import { useMoveToCategoryTab } from './moveToCategoryTab';
import { useMoveToCategory } from './moveToCategory';
import { useMoveToSetting } from './moveToSetting/moveToSetting';
import { useMoveToNotification } from './moveToNotification/moveToNotification';

export const useCommonNavigator = () => {
  const moveToWebview = useMoveToWebview();
  const moveToScreens = useMoveToScreens();
  const moveToHome = useMoveToHome();
  const moveToLikeFolders = useMoveToLikeFolders();
  const moveToLikeMarketList = useMoveToLikeMarketList();
  const moveToEditGoodsLike = useMoveToEditGoodsLike();
  const moveToCategoryTab = useMoveToCategoryTab();
  const moveToCategory = useMoveToCategory();
  const moveToSetting = useMoveToSetting();
  const moveToNotification = useMoveToNotification();

  return {
    moveToRoot,
    moveToWebview,
    moveToToday,
    moveToScreens,
    moveToHome,
    moveToLikeFolders,
    moveToLikeMarketList,
    moveToEditGoodsLike,
    moveToCategoryTab,
    moveToCategory,
    moveToSetting,
    moveToNotification,
  };
};
